export { default as RoleListTemplate } from './RoleListTemplate';



// WEBPACK FOOTER //
// ./src/themes/default/modules/role/pages/index.js